import React from 'react'

import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import View from '../Components/View/View'

function ViewPost(props) {
    return (
        <div>
            <Header />
            <View/>
            <Footer/>
        </div>
    )
}

export default ViewPost
